import { Box, Card, Text } from '@mantine/core'
import React from 'react'

const DigitalDataCard = (props) =>
{
    const { data } = props
    console.log(data)

    return (
        <Card w={'215px'} shadow="sm" p={0} radius={'6px'} style={{ backgroundColor: 'var(--color-white)', display: 'flex', flexDirection: 'row', justifyContent: 'space-around', minHeight: '60px', alignItems: 'stretch' }}>
            <Box w={'75%'} shadow="sm" radius={'6px'} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '6px 4px' }} >
                <Text size={'1rem'} weight={500} align='center' color='var(--color-bold-text)' style={{ lineHeight: 1.3 }}>{data.name}</Text>
            </Box>
            <Box w={'25%'} shadow="sm" radius={'6px'} bg={data.color} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', alignSelf: 'stretch' }}>
                <Text size={'1rem'} weight={400} color='var(--color-white)' align='center'>{data.value}</Text>
            </Box>
        </Card>
    )
}

export default DigitalDataCard
